import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Footer } from '../components/Footer';
import { ArrowLeft, Bell, Lock, User, CreditCard, Shield } from 'lucide-react';
import { ChangePasswordModal } from '../components/modals/ChangePasswordModal';
import { Setup2FAModal } from '../components/modals/Setup2FAModal';
export function SettingsPage() {
  const [isPasswordModalOpen, setIsPasswordModalOpen] = useState(false);
  const [is2FAModalOpen, setIs2FAModalOpen] = useState(false);
  const [settings, setSettings] = useState({
    emailNotifications: true,
    smsNotifications: false,
    inquiryAlerts: true,
    marketingEmails: false
  });
  return <div className="min-h-screen bg-[#f5f5f7] font-sans text-[#1f2933] flex flex-col" data-id="element-5740">
      {/* Header */}
      <header className="bg-white border-b border-gray-300 py-4 px-6 md:px-12" data-id="element-5741">
        <div className="max-w-7xl mx-auto flex justify-between items-center" data-id="element-5742">
          <Link to="/" className="flex items-center gap-2" data-id="element-5743">
            <div className="w-8 h-8 bg-[#1f2933] rounded-sm" data-id="element-5744"></div>
            <span className="font-bold text-xl tracking-tight" data-id="element-5745">
              Citiplots.com
            </span>
          </Link>
        </div>
      </header>

      <main className="flex-1 max-w-4xl mx-auto px-6 py-12 w-full" data-id="element-5746">
        <Link to="/dashboard" className="flex items-center gap-2 text-sm text-gray-600 hover:text-gray-900 mb-6" data-id="element-5747">
          <ArrowLeft className="w-4 h-4" data-id="element-5748" />
          Back to Dashboard
        </Link>

        <h1 className="text-3xl font-bold mb-8" data-id="element-5749">Account Settings</h1>

        {/* Profile Section */}
        <div className="bg-white border border-gray-300 p-8 mb-6" data-id="element-5750">
          <h2 className="font-bold text-lg mb-6 pb-2 border-b border-gray-200 flex items-center gap-2" data-id="element-5751">
            <User className="w-5 h-5" data-id="element-5752" />
            Profile Information
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-5753">
            <div data-id="element-5754">
              <label className="block text-sm font-bold text-gray-700 mb-1" data-id="element-5755">
                Full Name
              </label>
              <input type="text" defaultValue="John Doe" className="w-full p-2 border border-gray-300 bg-gray-50 focus:outline-none focus:border-gray-500" data-id="element-5756" />
            </div>
            <div data-id="element-5757">
              <label className="block text-sm font-bold text-gray-700 mb-1" data-id="element-5758">
                Email
              </label>
              <input type="email" defaultValue="john@example.com" className="w-full p-2 border border-gray-300 bg-gray-50 focus:outline-none focus:border-gray-500" data-id="element-5759" />
            </div>
            <div data-id="element-5760">
              <label className="block text-sm font-bold text-gray-700 mb-1" data-id="element-5761">
                Phone
              </label>
              <input type="tel" defaultValue="+91 98765 43210" className="w-full p-2 border border-gray-300 bg-gray-50 focus:outline-none focus:border-gray-500" data-id="element-5762" />
            </div>
            <div data-id="element-5763">
              <label className="block text-sm font-bold text-gray-700 mb-1" data-id="element-5764">
                Location
              </label>
              <input type="text" defaultValue="Mumbai, Maharashtra" className="w-full p-2 border border-gray-300 bg-gray-50 focus:outline-none focus:border-gray-500" data-id="element-5765" />
            </div>
          </div>
          <div className="mt-6 flex justify-end" data-id="element-5766">
            <button className="px-6 py-2 bg-[#1f2933] text-white text-sm font-bold hover:bg-gray-800" data-id="element-5767">
              Save Changes
            </button>
          </div>
        </div>

        {/* Security Section */}
        <div className="bg-white border border-gray-300 p-8 mb-6" data-id="element-5768">
          <h2 className="font-bold text-lg mb-6 pb-2 border-b border-gray-200 flex items-center gap-2" data-id="element-5769">
            <Shield className="w-5 h-5" data-id="element-5770" />
            Security
          </h2>
          <div className="space-y-4" data-id="element-5771">
            <div className="flex items-center justify-between p-4 border border-gray-200 bg-gray-50" data-id="element-5772">
              <div data-id="element-5773">
                <div className="font-bold text-sm mb-1" data-id="element-5774">Password</div>
                <div className="text-xs text-gray-500" data-id="element-5775">
                  Last changed 2 months ago
                </div>
              </div>
              <button onClick={() => setIsPasswordModalOpen(true)} className="px-4 py-2 border border-gray-300 text-sm font-bold hover:bg-white" data-id="element-5776">
                Change Password
              </button>
            </div>
            <div className="flex items-center justify-between p-4 border border-gray-200 bg-gray-50" data-id="element-5777">
              <div data-id="element-5778">
                <div className="font-bold text-sm mb-1" data-id="element-5779">
                  Two-Factor Authentication
                </div>
                <div className="text-xs text-gray-500" data-id="element-5780">
                  Add extra security to your account
                </div>
              </div>
              <button onClick={() => setIs2FAModalOpen(true)} className="px-4 py-2 bg-[#1f2933] text-white text-sm font-bold hover:bg-gray-800" data-id="element-5781">
                Enable 2FA
              </button>
            </div>
          </div>
        </div>

        {/* Notification Preferences */}
        <div className="bg-white border border-gray-300 p-8" data-id="element-5782">
          <h2 className="font-bold text-lg mb-6 pb-2 border-b border-gray-200 flex items-center gap-2" data-id="element-5783">
            <Bell className="w-5 h-5" data-id="element-5784" />
            Notification Preferences
          </h2>
          <div className="space-y-4" data-id="element-5785">
            <label className="flex items-center justify-between p-3 border border-gray-200 hover:bg-gray-50 cursor-pointer" data-id="element-5786">
              <div data-id="element-5787">
                <div className="font-bold text-sm" data-id="element-5788">Email Notifications</div>
                <div className="text-xs text-gray-500" data-id="element-5789">
                  Receive updates via email
                </div>
              </div>
              <input type="checkbox" checked={settings.emailNotifications} onChange={e => setSettings({
              ...settings,
              emailNotifications: e.target.checked
            })} className="w-4 h-4 accent-[#1f2933]" data-id="element-5790" />
            </label>
            <label className="flex items-center justify-between p-3 border border-gray-200 hover:bg-gray-50 cursor-pointer" data-id="element-5791">
              <div data-id="element-5792">
                <div className="font-bold text-sm" data-id="element-5793">SMS Notifications</div>
                <div className="text-xs text-gray-500" data-id="element-5794">
                  Receive updates via SMS
                </div>
              </div>
              <input type="checkbox" checked={settings.smsNotifications} onChange={e => setSettings({
              ...settings,
              smsNotifications: e.target.checked
            })} className="w-4 h-4 accent-[#1f2933]" data-id="element-5795" />
            </label>
          </div>
        </div>
      </main>

      <Footer data-id="element-5796" />

      <ChangePasswordModal isOpen={isPasswordModalOpen} onClose={() => setIsPasswordModalOpen(false)} data-id="element-5797" />
      <Setup2FAModal isOpen={is2FAModalOpen} onClose={() => setIs2FAModalOpen(false)} data-id="element-5798" />
    </div>;
}